module.exports = __webpack_public_path__ + "static/media/sniper-1.a2675987.png";